import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";

function Header() {
  return (
    <>
      <Navbar>
        <Container>
          <Navbar.Brand href="/">
            <img
              src="/images/logo-full.png"
              //width="30"
              height="40"
              className="d-inline-block align-top"
              alt="Boque Logo"
            />
          </Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <Nav>
              <Nav.Link href="/about" className="text-primary fw-bold">
                ABOUT
              </Nav.Link>
              <Nav.Link href="/contact" className="text-primary fw-bold">
                CONTACT
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
